import MainLayout from '@/layout/MainLayout.vue'
import IncidentIndex from '@/pages/operation-risk/incidents/IncidentIndex.vue'
import IncidentList from '@/pages/operation-risk/incidents/IncidentList.vue'
import SettlementIndex from '@/pages/operation-risk/settlement/SettlementIndex.vue'
import SettlementList from '@/pages/operation-risk/settlement/SettlementList.vue'
import IncidentCreate from '@/pages/operation-risk/incidents/create/IncidentCreate.vue'
import IncidentSingle from '@/pages/operation-risk/incidents/single/IncidentSingle.vue'
import IncidentOverview from '@/pages/operation-risk/incidents/single/tabs/Overview.vue'
import IncidentIssues from '@/pages/operation-risk/incidents/single/tabs/Issues.vue'
import IncidentExecutors from '@/pages/operation-risk/incidents/single/tabs/Executors.vue'
import IncidentAttachments from '@/pages/operation-risk/incidents/single/tabs/Attachments.vue'
import IncidentComments from '@/pages/operation-risk/incidents/single/tabs/Comments.vue'
import IncidentHistory from '@/pages/operation-risk/incidents/single/tabs/History.vue'

export default [
  {
    path: '/operation-risk',
    name: 'operation-risk',
    component: MainLayout,
    redirect: { name: 'incident-list' },
    meta: {
      title: 'Операційні ризики',
    },
    children: [
      {
        path: 'incidents',
        name: 'incidents',
        component: IncidentIndex,
        redirect: { name: 'incident-list' },
        meta: {
          title: 'Інциденти',
          resource: 'incidents',
        },
        children: [
          {
            path: '',
            name: 'incident-list',
            component: IncidentList,
            meta: {
              title: 'Реєстр інцидентів',
            },
          },
          {
            path: 'my',
            name: 'incident-my',
            component: IncidentList,
            meta: {
              title: 'Мої інциденти',
            },
          },
          {
            path: 'assigned',
            name: 'incident-assigned',
            component: IncidentList,
            meta: {
              title: 'Призначені мені',
            },
          },
          {
            path: 'create',
            name: 'incident-create',
            component: IncidentCreate,
            meta: {
              title: 'Новий інцидент',
            },
          },
          {
            path: ':id',
            name: 'incident-single',
            component: IncidentSingle,
            redirect: { name: 'incident-overview' },
            meta: {
              title: 'Інцидент',
              tabList: true,
            },
            children: [
              {
                path: 'overview',
                name: 'incident-overview',
                component: IncidentOverview,
                meta: {
                  title: 'Огляд',
                },
              },
              {
                path: 'issues',
                name: 'incident-issues',
                component: IncidentIssues,
                meta: {
                  title: 'Недоліки',
                },
              },
              {
                path: 'executors',
                name: 'incident-executors',
                component: IncidentExecutors,
                meta: {
                  title: 'Виконавці',
                },
              },
              {
                path: 'attachments',
                name: 'incident-attachments',
                component: IncidentAttachments,
                meta: {
                  title: 'Вкладення',
                },
              },
              {
                path: 'comments',
                name: 'incident-comments',
                component: IncidentComments,
                meta: {
                  title: 'Коментарі',
                },
              },
              {
                path: 'history',
                name: 'incident-history',
                component: IncidentHistory,
                meta: {
                  title: 'Історія змін',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'settlement',
        name: 'settlement',
        component: SettlementIndex,
        redirect: { name: 'settlement-list' },
        meta: {
          title: 'Врегулювання',
        },
        children: [
          {
            path: '',
            name: 'settlement-list',
            component: SettlementList,
            meta: {
              title: 'Врегулювання',
            },
          },
        ],
      },
      {
        path: '',
        redirect: { name: 'incident-list' },
      },
    ],
  },
]
